export default __webpack_public_path__ + "static/media/appointment-location.9e415191.png";